// ./src/contexts/VenueCategoriesContext/VenueCategoriesContext.tsx
//
// Thin context around useVenueCategories so the venue drawer / filter bar / bulk
// category modal share one load of the global category vocabulary.

import React, { createContext, useContext } from "react";

import { useVenueCategories, UseVenueCategoriesOptions, UseVenueCategoriesReturn } from "@/hooks/useVenueCategories";

const VenueCategoriesContext = createContext<UseVenueCategoriesReturn | null>(null);

export interface VenueCategoriesProviderProps extends UseVenueCategoriesOptions {
  children: React.ReactNode;
}

export const VenueCategoriesProvider: React.FC<VenueCategoriesProviderProps> = ({ children, ...options }) => {
  const value = useVenueCategories(options);

  return <VenueCategoriesContext.Provider value={value}>{children}</VenueCategoriesContext.Provider>;
};

export const useVenueCategoriesContext = (): UseVenueCategoriesReturn => {
  const context = useContext(VenueCategoriesContext);

  if (!context) {
    throw new Error(
      "useVenueCategoriesContext must be used within a <VenueCategoriesProvider>. " +
        "Wrap your component tree with <VenueCategoriesProvider> to fix this."
    );
  }

  return context;
};

export const useOptionalVenueCategoriesContext = (): UseVenueCategoriesReturn | null => {
  return useContext(VenueCategoriesContext);
};
